import { render, staticRenderFns } from "./CoachInsightsTable.vue?vue&type=template&id=88c4eb90"
import script from "./CoachInsightsTable.vue?vue&type=script&lang=js"
export * from "./CoachInsightsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports